<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-17 19:51:59
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceModiReason\viewAttendanceModiReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-07 14:01:26
-->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_attendanceModifiReason_form_editTitle')
        : $t('label_essweb_attendanceModifiReason_form_viewTitle')
    "
    :delBtn="hasBtn('delete-admin-attendance-modification-record')"
    backgroundClass="white"
    :initData="ReasonData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'attendance_modification_reason_name',
      'sequence',
      'attendance_modification_reason_description',
      'attendance_modification_reason_code',
      'remarks',
    ]"
    :editBtn="!iSEdited && hasBtn('edit-admin-attendance-modification-record')"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_attendanceModifiReason_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
    widthClass="max-1000"
  >
    <template v-slot:page-main>
      <v-form lazy-validation ref="form">
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :readonly="!iSEdited"
              :filled="iSEdited"
              :bindData="ReasonData.attendance_modification_reason_name"
              @change="
                (valueArr) => {
                  ReasonData.attendance_modification_reason_name = valueArr;
                }
              "
              :label="
                $t(
                  'label_essweb_attendanceModifiReason_form_attendancModifiReasonLabel'
                )
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
            Type
            <v-select
              :items="ReasonType"
              item-text="type_uuid"
              item-value="uuid"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :menu-props="{ offsetY: true,transition:'slide-y-transition',rounded:true,contentClass:'elevation-4' }"
              single-line
              v-model="ReasonData.type_uuid"
              label="Type"
              dense
            >
          <template v-slot:no-data>
            <noContent />
          </template></v-select>
          </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :label="
                $t('label_essweb_attendanceModifiReason_form_sequenceLabel')
              "
              isNotRequire
              :readonly="!iSEdited"
              :filled="iSEdited"
              type="number"
              v-model="ReasonData.sequence"
              :rules="$GetRules(['_Number_negative'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :label="$t('label_essweb_attendanceModifiReason_form_codeLabel')"
              :readonly="!iSEdited"
              :filled="iSEdited"
              v-model="ReasonData.attendance_modification_reason_code"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :readonly="!iSEdited"
              :filled="iSEdited"
              :bindData="ReasonData.attendance_modification_reason_description"
              @change="
                (valueArr) => {
                  ReasonData.attendance_modification_reason_description =
                    valueArr;
                }
              "
              :label="
                $t('label_essweb_attendanceModifiReason_form_descriptionLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_attendanceModifiReason_form_remakLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              dense
              counter="500"
              :readonly="!iSEdited"
              :filled="iSEdited"
              single-line
              v-model="ReasonData.remarks"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:page-actions>
      <CardActions
        saveBtn
        @save="toSave"
        @cancel="toBack(isChanged)"
        v-if="iSEdited"
      />
    </template>
    <template v-slot:tools-main></template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newAttendanceModiReason",
  computed: {
    ...mapGetters(["companyLang"]),
    TypeList() {
      return this.$getSelectTrans(this.TypeData, "type_name");
    },
  },
  data() {
    return {
      search: "",
      isChanged: false,
      iSEdited: false,
      ReasonData: {
        attendance_modification_reason_name: "",
        sequence: 1,
        attendance_modification_reason_description: "",
        attendance_modification_reason_code: "",
        remarks: "",
      },
      TypeData: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getDetail();
  },
  methods: {
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_reason",
        url: "/attendance-modification-reason/get-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["attendance_modification_reason_name_save"] =
          res.data.attendance_modification_reason_name;
        res.data.attendance_modification_reason_name =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.attendance_modification_reason_name
          );
        res.data["attendance_modification_reason_description_save"] =
          res.data.attendance_modification_reason_description;
        res.data.attendance_modification_reason_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.attendance_modification_reason_description
          );
        that.ReasonData = res.data;
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
        } else {
          this.$router.back();
        }
      }
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_reason",
        url: "/attendance-modification-reason/delete/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_attendanceModifiReason_list_deleteAttendancModifiReasonSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toBack: function () {
      if (this.iSEdited) {
        this.iSEdited = false;
      } else {
        this.$router.back();
      }
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_reason",
        url: "/attendance-modification-reason/update/",
        data: {
          uuid: this.$route.params.id,
          attendance_modification_reason_name: this.$transCommonLangKey(
            this.ReasonData.attendance_modification_reason_name,
            this.ReasonData.attendance_modification_reason_name_save
          ),
          attendance_modification_reason_description: this.$transCommonLangKey(
            this.ReasonData.attendance_modification_reason_description,
            this.ReasonData.attendance_modification_reason_description_save
          ),
          attendance_modification_reason_code:
            this.ReasonData.attendance_modification_reason_code,
          sequence: this.ReasonData.sequence,
          remarks: this.ReasonData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_attendanceModifiReason_list_updateAttendancModifiReasonSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
